import { useSelector } from 'react-redux';
import * as RampService from 'services/mailing/ramp';

export const useMailingRampService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchRamps = async (options = {}) => {
    const { error, payload } = await RampService.read({ ...options, token });
    if (error) {
      return {
        ramps: [],
        size: 0
      };
    }

    const {
      data: ramps,
      meta: { size }
    } = payload;
    return { ramps, size };
  };

  return { fetchRamps };
};
